import { render, staticRenderFns } from "./StationHeading.vue?vue&type=template&id=6f960b74&"
import script from "./StationHeading.vue?vue&type=script&lang=ts&"
export * from "./StationHeading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports